<pdf-viewer *ngIf="!bigFile"
[src]="currentPdf()"
[render-text]="true"
[original-size]="false"
style="display: block;"
[zoom]="zoom"
[page]="page"
[show-all]="false"
></pdf-viewer>

<div *ngIf="bigFile">
    <button (click)="zoomIn()">🔍 +</button>
    <button (click)="zoomOut()">🔍 -</button>
    <button (click)="prevPage()">⬅️</button>
    <button (click)="nextPage()">➡️</button>
  </div>
<pdf-viewer
  *ngIf="bigFile"
  [src]="pdfSrc!"
  [render-text]="false"
  [original-size]="false"
  [show-all]="false"
  [page]="page"
  [zoom]="zoom"
  style="display:block">
</pdf-viewer>